import { Component, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { LoadingPanelService } from 'src/app/shared/loading-panel/loading-panel.service';
import { ReportConfiguration } from '../../models/report-configuration';
import { ReportsService } from '../../services/reports.service';
import { SvgIconComponent } from '../../../shared/icons/svg-icon.component';
import { PermissionRequiredDirective } from '../../../shared/authentication/permission-required.directive';
import { ChangeLogLinkComponent } from '../../../shared/change-log/change-log-link/change-log-link.component';
import { ChangeLogLinkEntityDirective } from '../../../shared/change-log/change-log-link-entity/change-log-link-entity.directive';
import { ReportsOverviewGridComponent } from '../reports-overview-grid/reports-overview-grid.component';

@Component({
    selector: 'app-reports-overview',
    templateUrl: './reports-overview.component.html',
    styleUrls: ['./reports-overview.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [SvgIconComponent, PermissionRequiredDirective, ChangeLogLinkComponent, ChangeLogLinkEntityDirective, ReportsOverviewGridComponent]
})
export class ReportsOverviewComponent implements OnInit {
  private readonly loadingPanelService = inject(LoadingPanelService);
  private readonly reportsService = inject(ReportsService);

  reportConfigurations: ReportConfiguration[] = [];

  ngOnInit(): void {
    void this.refresh();
  }

  async refresh(): Promise<void> {
    try {
      this.loadingPanelService.showLoadingPanelDirect('Loading reports...');
      this.reportConfigurations = await this.reportsService.getReportConfigurations();
    }
    finally {
      this.loadingPanelService.hideLoadingPanel();
    }
  }

  onDeleteReportConfiguration(reportConfiguration: ReportConfiguration): Promise<number> {
    return this.reportsService.deleteReportConfiguration(reportConfiguration.Report.Id);
  }
}
